"use client";

import { useNeedsMerge, useResolveMerge } from "../hooks/use-ats-needs-merge";
import { NeedsMergeItem } from "./needs-merge-item";

export function NeedsMergeQueue({ jobId }: { jobId: string }) {
  const { items, isLoading } = useNeedsMerge(jobId);
  const resolve = useResolveMerge(jobId);

  function handleResolve(
    itemId: string,
    resolution: "merge" | "keep_separate",
    profileId?: string,
  ) {
    resolve.mutate({
      linkId: itemId,
      data: { resolution, target_profile_id: profileId ?? null },
    });
  }

  if (!isLoading && items.length === 0) {
    return (
      <div className="rounded-lg border border-border p-6 text-center text-sm text-contrast/50">
        Nothing to review — no ambiguous ATS candidates.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => (
        <NeedsMergeItem
          key={item.id}
          item={item}
          pending={resolve.isPending}
          onResolve={handleResolve}
        />
      ))}
    </div>
  );
}
